(function () {
  'use strict';
  var ttl = 30 * 60 * 1000;
  var configs = {
    PrepareHQContact: ['contact[name]', 'contact[email]', 'contact[Topic]', 'contact[Recipe]', 'contact[Order number]', 'contact[body]'],
    PrepareHQLargeOrder: ['contact[Reserve option]', 'contact[name]', 'contact[email]', 'contact[phone]', 'contact[Delivery postcode]', 'contact[body]']
  };
  function mount(marker) {
    var form = marker.closest('form');
    if (!form || !Object.prototype.hasOwnProperty.call(configs, form.id) || form.dataset.phqEnquiryReady) return;
    form.dataset.phqEnquiryReady = 'true';
    var fields = configs[form.id];
    var key = 'preparehq.enquiry-attempt.v1.' + form.id;
    var state = marker.getAttribute('data-phq-enquiry-state');
    var pathname = window.location.pathname;
    var expiryTimer;
    function remove() {
      try { window.sessionStorage.removeItem(key); } catch (error) { /* Storage can be blocked. Native forms still work. */ }
      window.clearTimeout(expiryTimer);
    }
    function scheduleExpiry(expires) {
      window.clearTimeout(expiryTimer);
      expiryTimer = window.setTimeout(remove, Math.max(0, expires - Date.now()));
    }
    function field(name) {
      var control = form.elements.namedItem(name);
      return control && /^(INPUT|TEXTAREA|SELECT)$/.test(control.tagName) ? control : null;
    }
    var pending = null;
    try {
      var raw = window.sessionStorage.getItem(key);
      if (raw && raw.length < 50000) pending = JSON.parse(raw);
      if (raw && (!pending || pending.version !== 1 || pending.path !== pathname || !Number.isFinite(pending.expires) || pending.expires <= Date.now() || pending.expires > Date.now() + ttl || !pending.values || typeof pending.values !== 'object' || Array.isArray(pending.values))) {
        remove(); pending = null;
      }
    } catch (error) { remove(); pending = null; }
    if (state === 'success') {
      remove();
      pending = null;
      window.addEventListener('pageshow', remove);
    }
    if (pending) scheduleExpiry(pending.expires);
    // Replay only after actual server-rendered errors, never on an unrelated visit.
    var restored = false;
    if (state === 'errors' && pending) {
      fields.forEach(function (name) {
        var control = field(name), value = pending.values[name];
        if (!control || typeof value !== 'string' || value.length > 20000) return;
        if (control.tagName === 'SELECT') {
          // A server-restored option or a choice already made by the visitor wins.
          if (control.selectedIndex !== 0 || Array.prototype.some.call(control.options, function (option) { return option.defaultSelected; })) return;
          if (!Array.prototype.some.call(control.options, function (option) { return option.value === value; })) return;
        } else if (control.value) return;
        if (control.value !== value) { control.value = value; restored = true; }
      });
    }
    if (restored) {
      var notice = form.querySelector('[data-phq-enquiry-recovered]');
      if (notice) notice.hidden = false;
    }
    // The URL supplies a canonical recipe ID only. Never use URL text as HTML or a message.
    if (state === 'initial' && form.id === 'PrepareHQContact') {
      var source = form.querySelector('[data-phq-enquiry-recipes]');
      var recipe = field('contact[Recipe]');
      var topic = field('contact[Topic]');
      try {
        var ids = new URL(window.location.href).searchParams.getAll('phq_recipe');
        var names = JSON.parse(source.textContent);
        if (ids.length === 1 && Object.prototype.hasOwnProperty.call(names, ids[0]) && typeof names[ids[0]] === 'string' && recipe && !recipe.value) {
          recipe.value = names[ids[0]];
          if (topic && topic.selectedIndex === 0) topic.value = 'Recipe question';
        }
      } catch (error) { /* Unknown or malformed context leaves an ordinary contact form. */ }
    }
    // Save only on an attempted native submission, never while the visitor is typing.
    // No payment data, hidden payloads, persistent localStorage or network calls are used.
    form.addEventListener('submit', function () {
      var values = {}, size = 0;
      fields.forEach(function (name) {
        var control = field(name);
        if (!control) return;
        values[name] = control.value;
        size += control.value.length;
      });
      if (size > 20000) { remove(); return; }
      var expires = Date.now() + ttl;
      try {
        window.sessionStorage.setItem(key, JSON.stringify({version:1, path:pathname, expires:expires, values:values}));
        scheduleExpiry(expires);
      } catch (error) { remove(); }
    }, true);
    form.addEventListener('reset', remove);
  }
  function start() { document.querySelectorAll('[data-phq-enquiry-state]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
}());
